"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageService = void 0;
var localforage_1 = __importDefault(require("localforage"));
var reactNativeStore_1 = __importDefault(require("./reactNativeStore"));
var StorageService = /** @class */ (function () {
    function StorageService(_a) {
        var _this = this;
        var name = _a.name, storeName = _a.storeName, appType = _a.appType, _b = _a.driver, driver = _b === void 0 ? localforage_1.default.LOCALSTORAGE : _b;
        // implements LocalForageDbMethodsCore
        this.getEvent = function (key) { return _this.store.getItem(key); };
        this.putEvent = function (key, value) { return _this.store.setItem(key, value); };
        switch (appType) {
            case 'web':
                this.store = localforage_1.default.createInstance({ driver: driver, name: name, storeName: storeName });
                break;
            case 'react-native':
                this.store = reactNativeStore_1.default.createInstance({ name: name, storeName: storeName });
                break;
        }
    }
    return StorageService;
}());
exports.StorageService = StorageService;
